module.exports = __webpack_public_path__ + "img/pureepommedeterre.5253f6b6.png";